<div [formGroup]="form">
  <div class="flex items-center mb-4">

    <label nz-checkbox formControlName="sendToMobile">
      {{ 'addVisit.form.sendToMobile' | translate }}
    </label>
  </div>
  <div class="flex items-center mb-4">

    <beautyapp-input
      label="ელექტრონული ფოსტა"
      formControlName="email"
      placeholder="{{ 'ელექტრონული ფოსტის მისამართი' | translate }}"
      class="ml-4 w-full"
      prefixIcon="mail"
    ></beautyapp-input>
  </div>
</div>

<div *nzModalFooter class="mt-6 flex justify-end space-x-3">
  <button nz-button type="button" nzType="default"
          (click)="modalRef.close(false)">
    {{ 'buttons.close' | translate }}
  </button>
  <button nz-button type="button" nzType="primary"
          [disabled]="form.invalid"
          [nzLoading]="loading()"
          (click)="sendRecipe()">
    {{ 'buttons.sendEmail' | translate }}
  </button>
</div>
